"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreRegistrantDispatcher = usePreRegistrantDispatcher;
exports.usePreRegistrant = usePreRegistrant;
Object.defineProperty(exports, "ClientProvider", {
  enumerable: true,
  get: function get() {
    return _urql.Provider;
  }
});
Object.defineProperty(exports, "createClient", {
  enumerable: true,
  get: function get() {
    return _urql.createClient;
  }
});
exports.PreRegistrantProvider = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _react = _interopRequireWildcard(require("react"));

var _urql = require("urql");

var _constants = require("./utils/constants");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Cache = {
  getPreRegistrant: function getPreRegistrant() {
    return JSON.parse(localStorage.getItem(_constants.StorageKey.REGISTRANT) || 'null');
  },
  setPreRegistrant: function setPreRegistrant(reg) {
    localStorage.setItem(_constants.StorageKey.REGISTRANT, JSON.stringify(reg));
  }
};
var PreRegistrant = (0, _react.createContext)(null);
var PreRegistrantDispatcher = (0, _react.createContext)(function (reg) {});

var PreRegistrantProvider = function PreRegistrantProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(function () {
    return Cache.getPreRegistrant();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      preRegistrant = _useState2[0],
      setPreRegistrant = _useState2[1];

  var dispatchNewRegistrant = (0, _react.useCallback)(function (reg) {
    setPreRegistrant(reg);
    Cache.setPreRegistrant(reg);
  }, [setPreRegistrant]);
  return _react.default.createElement(PreRegistrantDispatcher.Provider, {
    value: dispatchNewRegistrant
  }, _react.default.createElement(PreRegistrant.Provider, {
    value: preRegistrant
  }, children));
};

exports.PreRegistrantProvider = PreRegistrantProvider;

function usePreRegistrantDispatcher() {
  return (0, _react.useContext)(PreRegistrantDispatcher);
}

function usePreRegistrant() {
  return (0, _react.useContext)(PreRegistrant);
}